// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1516227481792
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./components/loader/loader.scss
// module id = 101
// module chunks = 0